import React, { useEffect } from 'react';

const InstagramWidgetTendance = () => {
  useEffect(() => {
    // Dynamically add the Elfsight platform script
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);

    // Cleanup to remove the script if the component is unmounted
    return () => {
      document.body.removeChild(script);
    };
  }, []);


  return (
    <div>
      {/* Include the Elfsight widget div */}
      <div
        className="elfsight-app-d5058738-bc11-467d-8fa2-cb48ffd3a4d7"
        data-elfsight-app-lazy
      ></div>
    </div>
  );
};

export default InstagramWidgetTendance;
